module.exports = __webpack_public_path__ + "static/media/overview-large@3x.ffa84578.png";